import { createEpmConfigRoutes } from '@pats/epm-config-react-app/manifest'
import type { AuthState, FeatureInfo } from '@sparky/framework'
import { getEpmConfigRootKey, isFeatureEnabled } from './feature'
import { i18n } from './i18n'
import { extensions } from './extensions'

const manifest = {
	default: async ({ auth }: { auth: AuthState }) => {
		const intl = i18n(navigator.language ?? 'en')
		const isPanoramaTenant = !!auth.instances.get('prisma_access_edition_onprem')
		const isPbaTenant = !!auth.properties?.['fawkes.license']?.value?.is_pba_enabled
		const epmConfigRoot = getEpmConfigRootKey(isPanoramaTenant)
		const epmConfigRootPath = `/${epmConfigRoot}`

		const epmConfigRoutes = createEpmConfigRoutes(epmConfigRootPath)
		const isPanHybridEnabled = auth?.feature_flags?.getValue('epm.activation.isPanHybrid')
		const isNgfwEnabled = auth?.feature_flags?.getValue('epm.activation.isNgfw')
		const isMfeFeatureEnabled = isPanHybridEnabled || isNgfwEnabled

		return [
			{
				key: 'manage',
				path: '/manage',
				mergeNav: true,
				children: [
					{
						key: 'epm-inventory',
						path: '/manage/epm/inventory',
						title: intl.formatMessage({ defaultMessage: 'Prisma Access Agent', id: 'xtExMx' }),
						contentClassName: 'panwds-tw3',
						avail({ featuresInfo }: { featuresInfo: FeatureInfo[] }) {
							return isPbaTenant || isFeatureEnabled(featuresInfo, 'ztna_agent') || isMfeFeatureEnabled
						},
						component: () => import('../main').then((m) => m.activate())
					}
				]
			},
			{
				key: epmConfigRoot,
				path: epmConfigRootPath,
				mergeNav: true,
				children: [
					{
						key: epmConfigRoutes.default.key,
						path: epmConfigRoutes.default.path,
						title: intl.formatMessage({ defaultMessage: 'Prisma Access Agent', id: 'xtExMx' }),
						avail() {
							return !isPbaTenant && isMfeFeatureEnabled
						},
						contentClassName: 'panwds-tw3',
						component: () => import('../epm-config').then((m) => m.activate(epmConfigRootPath)),
						children: [
							{
								key: epmConfigRoutes.setup_infrastructure.key,
								path: epmConfigRoutes.setup_infrastructure.path,
								title: intl.formatMessage({ defaultMessage: 'Setup', id: 'dvr19k' })
							},
							{
								key: epmConfigRoutes.forwarding_profiles.key,
								path: epmConfigRoutes.forwarding_profiles.path,
								title: intl.formatMessage({ defaultMessage: 'Forwarding Profiles', id: 'sll10a' })
							}
						]
					}
				]
			}
		]
	},
	extensions: extensions
}

export { manifest }
